type ErrorCode =
  | 'GENERIC'
  | 'INCOMPLETE_BET'
  | 'DO_NOT_USE'
  | 'UNSUPPORTED_VALUE_GENERIC'
  | 'UNSUPPORTED_VALUE_PRODUCT_ID'
  | 'UNSUPPORTED_VALUE_SYSTEM_TYPE'
  | 'UNSUPPORTED_VALUE_REDUCTION'
  | 'UNSUPPORTED_VALUE_BET_PROP'
  | 'UNSUPPORTED_VALUE_BOARD_PROP'
  | 'UNSUPPORTED_VALUE_ROW_PRICE'
  | 'UNSUPPORTED_VALUE_SYSTEM_NUMBER'
  | 'UNSUPPORTED_VALUE_DRAW_COUNT'
  | 'EVENT_BOUNDS';

export class WagerError extends Error {
  private readonly _code;

  constructor({ clientCode, message }: { clientCode?: ErrorCode; message: string }) {
    super(message);

    this._code = clientCode ?? 'GENERIC';
    this.name = 'WagerError';
  }

  get code(): ErrorCode {
    return this._code;
  }

  toJSON(): {
    message: string;
  } {
    return {
      message: this.message,
    };
  }

  override toString(): string {
    return JSON.stringify(this.toJSON());
  }
}
